<template>
  <b-form-select 
    :value="value" 
    @input="$emit('input', $event)"
    :disabled="disabled"
    :state="state"
  >
    <option :value="null">{{ placeholder }}</option>
    <optgroup 
      v-for="grupo in gruposMenus" 
      :key="grupo.titulo" 
      :label="grupo.titulo"
    >
      <option 
        v-for="menu in grupo.menus" 
        :key="menu.ID" 
        :value="menu.URL"
      >
        {{ menu.NAME }}
      </option>
    </optgroup>
  </b-form-select>
</template>

<script>
/**
 * MenuDropdown - Componente para seleção de tela inicial
 * 
 * Exibe lista hierárquica de menus disponíveis para configuração
 * como tela inicial do usuário ou grupo de acesso.
 */
export default {
  name: 'MenuDropdown',
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Selecione uma tela inicial (opcional)'
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    /**
     * Menus disponíveis organizados hierarquicamente
     * Agrupa por categoria (pai) para melhor visualização
     */
    gruposMenus() {
      const todosMenus = this.$store.getters['menu/LISTA'] || []
      
      // Filtra apenas menus navegáveis (com URL válida, ativos, não-títulos)
      // REQUISITO: URL is not null (apenas menus com URL podem ser tela inicial)
      const menusNavegaveis = todosMenus.filter(m => 
        m.URL !== null &&        // ✅ URL não pode ser null
        m.URL !== undefined &&   // ✅ URL não pode ser undefined
        m.URL !== '' &&          // ✅ URL não pode ser vazia
        m.TITLE !== 'true' &&    // ✅ Não é título de grupo
        m.EXIBIR === 'S'         // ✅ Menu está ativo
        // Nota: UNICO='S' permitido (ex: Painel Vendedor pode ser tela inicial)
      )
      
      // Agrupa por categoria (PAI_ID)
      const grupos = {}
      const menusPai = {}
      
      // Primeiro passo: identifica os menus pai (títulos de grupo)
      todosMenus.forEach(m => {
        if (m.TITLE === 'true' && m.NAME) {
          menusPai[m.ID] = m.NAME
        }
      })
      
      // Segundo passo: agrupa filhos por pai
      menusNavegaveis.forEach(menu => {
        const paiId = menu.PAI_ID
        const nomePai = menusPai[paiId] || 'Outros'
        
        if (!grupos[nomePai]) {
          grupos[nomePai] = []
        }
        
        grupos[nomePai].push(menu)
      })
      
      // Converte objeto em array ordenado
      const gruposArray = Object.keys(grupos)
        .sort()
        .map(titulo => ({
          titulo: titulo,
          menus: grupos[titulo].sort((a, b) => a.NAME.localeCompare(b.NAME))
        }))
      
      return gruposArray
    }
  }
}
</script>

<style scoped>
/* Melhora visual do select */
select {
  cursor: pointer;
}

select:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/MenuDropdown.vue